import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Styles/BlogList.css";

const BlogList = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchBlogs();
        checkAdminStatus();
    }, []);

    const checkAdminStatus = async () => {
        try {
            const cookies = document.cookie.split("; ");
            const userEmailCookie = cookies.find(row => row.startsWith("userEmail="));
            if (userEmailCookie) {
                const email = userEmailCookie.split("=")[1];
                const response = await fetch(`https://dalhousiecombatroboticsteam.onrender.com/check-admin?email=${email}`);
                const data = await response.json();
                setIsAdmin(data.isAdmin);
            }
        } catch (error) {
            console.error("Error checking admin status:", error);
        }
    };

    const fetchBlogs = async () => {
        try {
            console.log('Fetching blogs...');
            const response = await fetch("https://dalhousiecombatroboticsteam.onrender.com/blogs");
            const data = await response.json();

            console.log('Server response:', data);

            if (!response.ok) {
                throw new Error(data.message || "Failed to fetch blogs");
            }

            setBlogs(data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching blogs:", error);
            setError(error.message || "Failed to load blogs. Please try again later.");
            setLoading(false);
        }
    };

    const handleBlogClick = (blogId) => {
        navigate(`/blog/${blogId}`);
    };

    const handleDelete = async (blogId, event) => {
        event.stopPropagation(); // Prevent navigation when clicking delete
        if (!window.confirm("Are you sure you want to delete this blog post?")) {
            return;
        }

        try {
            const response = await fetch(`https://dalhousiecombatroboticsteam.onrender.com/blog/${blogId}`, {
                method: 'DELETE',
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Failed to delete blog");
            }

            setBlogs(blogs.filter(blog => blog._id !== blogId));
            alert("Blog post deleted successfully!");
        } catch (error) {
            console.error("Error deleting blog:", error);
            alert(error.message || "Failed to delete blog post");
        }
    };

    if (loading) {
        return (
            <div className="blog-list-container">
                <div className="loading-spinner">Loading...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="blog-list-container">
                <div className="error-message">
                    <h3>Error</h3>
                    <p>{error}</p>
                    <button onClick={fetchBlogs} className="retry-button">
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="blog-list-container">
            <h2>Blog</h2>
            {blogs.length === 0 ? (
                <div className="no-blogs">
                    <p>No blog posts yet.</p>
                    <p className="sub-text">Be the first to create a blog post!</p>
                </div>
            ) : (
                <div className="blog-grid">
                    {blogs.map((blog) => (
                        <div
                            key={blog._id}
                            className="blog-card"
                            onClick={() => handleBlogClick(blog._id)}
                        >
                            {blog.images && blog.images.length > 0 && (
                                <div className="blog-image">
                                    <img src={blog.images[0]} alt={blog.title} />
                                </div>
                            )}
                            <div className="blog-content">
                                <div className="blog-header">
                                    <h3>{blog.title}</h3>
                                    {isAdmin && (
                                        <button
                                            className="delete-button"
                                            onClick={(e) => handleDelete(blog._id, e)}
                                            title="Delete blog post"
                                        >
                                            Delete Blog
                                        </button>
                                    )}
                                </div>
                                <p className="blog-meta">
                                    By {blog.author} • {new Date(blog.createdAt).toLocaleDateString()}
                                </p>
                                <p className="blog-description">{blog.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default BlogList; 